import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import SurveyListItemBox from '@ui-parts/SurveyListItemBox';
import SurveySearchBox from '@pages/Admin/Mypage/organisms/SurveySearchBox';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';
import { CombinedState } from '@reduxjs/toolkit';
import { RootState } from '~/App/store';
import { FONT_SIZES } from '~/assets/styles/base';
import { SESSION_STORAGES } from '~/constants';

const MyPageWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const SurveyListWrapper = styled.div`
  display: inline-block;
  margin: 0 auto;
  padding: 3px;
  width: 960px;
`;

const TitleWrapper = styled.div`
  width: 100%;
  text-align: left;
  font-size: ${FONT_SIZES.title1};
  padding-bottom: 10px;
`;

const Title = styled(Typography)`
  font-size: ${FONT_SIZES.title1};
  padding-bottom: 10px;
`;

const AdminMypage: React.FC = () => {
  const surveys = useSelector((state: CombinedState<RootState>) => state.surveys);
  const { t } = useTranslation();

  // 検索条件の初期値は条件保存したストレージの値
  const conditions = JSON.parse(
    sessionStorage.getItem(SESSION_STORAGES.SURVEY_SEARCH_BOX_CONDITIONS) || 'null'
  );

  return (
    <MyPageWrapper>
      <SurveyListWrapper>
        <TitleWrapper>
          <Title>{t('appCommon.enqueteList')}</Title>
        </TitleWrapper>
        <SurveySearchBox initState={conditions} />
        {Array.isArray(surveys) &&
          surveys.length > 0 &&
          surveys.map((survey) => <SurveyListItemBox isAdmin survey={survey} key={survey.id} />)}
      </SurveyListWrapper>
    </MyPageWrapper>
  );
};

export default AdminMypage;
